import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { useForm } from "react-hook-form";
import { bindActionCreators } from "redux";
import CipHeader from "../Components/CipHeader";
import CutOffScreenTab from "../Components/CutOffScreenTab";
import FacNotReady from "../Components/facNotReady";
import AuditFacTab from "../Components/AuditFacTab";
import PackingSlipTab from "../Components/PackingSlipTab";
import PackingPublishListTab from "../Components/packingPublishListTab";
import cogoToast from "cogo-toast";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";
import shipingService from "../services/shiping-service";

const ShipingScan = ({ history }) => {
  const { register, getValues, setValue } = useForm({});
  const [loading, setLoading] = useState(false);
  const [openTab, setOpenTab] = React.useState(1);
  const [facilityNameFdx, setFacilityNameFdx] = useState("");
  const getScanDetails = async (e) => {
    if (e.key === "Enter") {
      setLoading(true);
      const rxCode = getValues("rxCode");
      if (rxCode) {
        try {
          let resp = await shipingService.getFacDetails(rxCode);
          setFacilityNameFdx(resp.fac_dname + "  (" + resp.fdx_code + ")");
          let fxd_delivry = resp.fdx_delivery ? resp.fdx_delivery : "";
          let fxd_remarks = resp.remarks ? resp.remarks : "";
          let fac_workflow = resp.fac_workflow ? resp.fac_workflow : "";
          //window.open('clinicalsolutions:'+resp.fac_dname+'|'+resp.fdx_code+'|'+resp.fdx_service+'|'+resp.fdx_delivery+'|'+'','_self');
          let facArr = [
            "CAFC-E",
            "CAFC-INF",
            "CAFC-W",
            "CCDF",
            "CCDF-F",
            "LPCC",
            "SDGA",
            "WCCC",
            "WHGA",
          ];
          const dateObj = new Date();
          let day = dateObj.getDay();
          let code = resp.fdx_code;
          if (
            resp.fdx_service.toString().startsWith("P") &&
            day === 5 &&
            facArr.find((element) =>
              resp.fdx_code.toString().startsWith(element)
            )
          ) {
            code = code + "P";
          }
          
          window.open(
            "clinicalsolutions:" +
              resp.fac_dname +
              "|" +
              code +
              "|" +
              resp.fdx_service +
              "|" +
              fxd_delivry +
              "|" +
              fxd_remarks +
              "|" +
              fac_workflow +
              "",
            "_self"
          );
          setValue("rxCode", "");
          setFacilityNameFdx("");
          document.getElementById("rxCode").select();
        } catch (e) {
          setValue("rxCode", "");
          setFacilityNameFdx("");
          const { hide } = cogoToast.error(
            "Error retrieving details. Please contact administrator.",
            {
              hideAfter: 15,
              onClick: () => {
                hide();
              },
            }
          );
        }
      } else {
        const { hide } = cogoToast.error("Please enter RX Code.", {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        });
      }
      setLoading(false);
    }
  };
  const gotoNextField = async (e) => {
    if (e.key === "Enter") {
      document.getElementById("subseqRxCodeField").select();
    }
  };
  const checkDropStatus = async (e) => {
    if (e.key === "Enter") {
      setLoading(true);
      const subseqRxCode = getValues("subseqRxCode");
      let subseqdropFacId = getValues("subseqdropFacId");
      let lastChar = subseqdropFacId.toString().charAt(subseqdropFacId.length-1);
      subseqdropFacId = isNaN(lastChar)
            ? subseqdropFacId.toString().substring(0, subseqdropFacId.length - 1)
            : subseqdropFacId;
      let params = {
        subseqRxCode: subseqRxCode,
        subseqdropFacId: subseqdropFacId,
      };
      if (subseqRxCode && subseqdropFacId) {
        try {
          let resp = await shipingService.getSubsequentDetails(params);
          const { hide } = cogoToast.success(resp, {
            hideAfter: 15,
            onClick: () => {
              hide();
            },
          });
          document.getElementById("subseqdropFacId").select();
        } catch (e) {
          const { hide } = cogoToast.error("Wrong Facility.", {
            hideAfter: 15,
            onClick: () => {
              hide();
            },
          });
          document.getElementById("subseqdropFacId").select();
        }
        setValue("subseqdropFacId", "");
        setValue("subseqRxCode", "");
      } else {
        const { hide } = cogoToast.error(
          "Please enter RX Code and Facility Id",
          {
            hideAfter: 15,
            onClick: () => {
              hide();
            },
          }
        );
        setLoading(false);
      }
      document.getElementById("subseqdropFacId").select();
      setLoading(false);
    }
  };

  useEffect(() => {}, []);
  return (
    <>
      <CipHeader />
      <div
        className={`inline-block customtop z-50 absolute ${
          loading ? "show" : "hidden"
        }`}
      >
        <Loader
          type="Oval"
          color="#00B2A9"
          height={50}
          width={50}
          timeout={300000}
        />
      </div>
      <div className="bg-white w-3/4 mx-auto mt-6 mb-4 rounded shadow-md">
        <div className="tableHeader flex clearboth shadow-md py-8 pl-3">
          <div className="w-1/2 text-darkclr font-semibold leading-10 ">
            <span className="text-xl">SHIPPING APP</span>
          </div>
        </div>
        <ul
          className="flex mb-0 list-none flex-wrap pt-3 pb-4 flex-row"
          role="tablist"
        >
          <li className="mr-2 flex-auto text-center">
            <a
              className={
                "text-xs font-bold uppercase px-2 py-3 shadow-lg rounded block leading-normal " +
                (openTab === 1 ? "text-black bg-menu_active" : " bg-black")
              }
              onClick={(e) => {
                e.preventDefault();
                setOpenTab(1);
              }}
              data-toggle="tab"
              href="#link1"
              role="tablist"
            >
              SCAN RX
            </a>
          </li>
          <li className="mr-2 flex-auto text-center">
            <a
              className={
                "text-xs font-bold uppercase px-2 py-3 shadow-lg rounded block leading-normal " +
                (openTab === 2 ? "text-black bg-menu_active" : " bg-black")
              }
              onClick={async (e) => {
                e.preventDefault();
                setOpenTab(2);
              }}
              data-toggle="tab"
              href="#link2"
              role="tablist"
            >
              CUTOFF FACILITIES
            </a>
          </li>
          <li className="mr-2 flex-auto text-center">
            <a
              className={
                "text-xs font-bold uppercase px-2 py-3 shadow-lg rounded block leading-normal " +
                (openTab === 6 ? "text-black bg-menu_active" : " bg-black")
              }
              onClick={async (e) => {
                e.preventDefault();
                setOpenTab(6);
              }}
              data-toggle="tab"
              href="#link6"
              role="tablist"
            >
              NOT READY
            </a>
          </li>

          <li className="mr-2 flex-auto text-center">
            <a
              className={
                "text-xs font-bold uppercase px-2 py-3 shadow-lg rounded block leading-normal " +
                (openTab === 3 ? "text-black bg-menu_active" : "bg-black")
              }
              onClick={(e) => {
                e.preventDefault();
                setOpenTab(3);
              }}
              data-toggle="tab"
              href="#link3"
              id="link3"
              role="tablist"
            >
              AUDIT
            </a>
          </li>
          <li className="mr-2 flex-auto text-center">
            <a
              className={
                "text-xs font-bold uppercase px-2 py-3 shadow-lg rounded block leading-normal " +
                (openTab === 4 ? "text-black bg-menu_active" : "bg-black")
              }
              onClick={(e) => {
                e.preventDefault();
                setOpenTab(4);
              }}
              data-toggle="tab"
              href="#link4"
              role="tablist"
            >
              PACKING SLIP
            </a>
          </li>
          <li className="mr-2 flex-auto text-center">
            <a
              className={
                "text-xs font-bold uppercase px-2 py-3 shadow-lg rounded block leading-normal " +
                (openTab === 5 ? "text-black bg-menu_active" : "bg-black")
              }
              onClick={(e) => {
                e.preventDefault();
                setOpenTab(5);
              }}
              data-toggle="tab"
              href="#link5"
              role="tablist"
            >
              Published List
            </a>
          </li>
        </ul>
        <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded">
          <div className="flex-auto">
            <div className="tab-content tab-space">
              {openTab === 1 ? (
                <div id="link1" className="px-12 py-5">
                  <div>
                    <span className="text-darkclr font-semibold text-sm">
                      FIRST SCAN
                    </span>
                  </div>
                  <div>
                    <ul>
                      <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
                        <input
                          type="text"
                          name="rxCode"
                          id="rxCode"
                          autoFocus={true}
                          placeholder="Enter RX Code"
                          ref={register({
                            required: "You must enter RX Code",
                          })}
                          onKeyDown={getScanDetails}
                          className="border focus:outline-none focus:none h-10 rounded-md pl-3 text-sm font-normal w-full"
                        />
                      </li>
                      <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
                        {facilityNameFdx}
                      </li>
                    </ul>
                  </div>
                  <div className="text-left ">
                    <span className="text-darkclr font-semibold text-sm">
                      SUBSEQUENT DROPS
                    </span>
                  </div>
                  <div className="text-left">
                    <ul>
                      <li
                        className="inline-block text-xs leading-6 text-menu_txt w-full mb-3"
                      >
                        <label className="text-labelclr font-semibold text-sm tracking-wider">Facility</label>
                        <span className="text-xs md:text-sm text-hlred ml-1">
                          *
                        </span>
                        <input
                          type="text"
                          name="subseqdropFacId"
                          id="subseqdropFacId"
                          placeholder="Enter Facility ID"
                          ref={register({
                            required: "You must enter Facility ID",
                          })}
                          onKeyDown={gotoNextField}
                          className={`border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm`}
                        />
                      </li>
                      <li
                        className={`inline-block text-xs leading-10 text-menu_txt w-full`}
                      >
                        <label className="text-labelclr font-semibold text-sm tracking-wider">RX Code</label>
                        <span className="text-xs md:text-sm text-hlred ml-1">
                          *
                        </span>
                        <input
                          type="text"
                          name="subseqRxCode"
                          id="subseqRxCodeField"
                          placeholder="Enter RX Code"
                          ref={register({
                            required: "You must enter RX Code",
                          })}
                          onKeyDown={checkDropStatus}
                          className={`border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm`}
                        />
                      </li>
                    </ul>
                  </div>
                </div>
              ) : null}
              {openTab === 2 ? (
                <div id="link2">
                  <CutOffScreenTab />
                </div>
              ) : null}
              {openTab === 6 ? (
                <div id="link6">
                  <FacNotReady />
                </div>
              ) : null}
              {openTab === 3 ? (
                <div id="link3">
                  <AuditFacTab openTab={openTab} setOpenTab={setOpenTab} />
                </div>
              ) : null}
              {openTab === 4 ? (
                <div id="link4">
                  <PackingSlipTab />
                </div>
              ) : null}
              {openTab === 5 ? (
                <div id="link5">
                  <PackingPublishListTab />
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default withRouter(
  connect(
    () => ({}),
    (dispatch) => {
      return bindActionCreators({}, dispatch);
    }
  )(ShipingScan)
);
